// November 15th, 2021 12:00am EST
export const quinciLaunchDateUTC: Date = new Date(Date.UTC(2021, 10, 15, 5, 0, 0, 0));

// November 29th, 2021 12:00am EST
export const quinciHardDeadlineDateUTC: Date = new Date(Date.UTC(2021, 10, 29, 5, 0, 0, 0));